import { breakpoints, pxToRem, theme } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
import { SidebarDraggableHover, barStyles } from '../styled';
import { SIDEBAR_MAX_WIDTH, SIDEBAR_MIN_WIDTH } from '../useScreenSidebar';
export const FLOATING_SIDEBAR_CSS_VARIABLE_WIDTH = '--screen-layout-floating-sidebar-width';
const floatingSidebarWidth = css `
  ${(props) => `${FLOATING_SIDEBAR_CSS_VARIABLE_WIDTH}: ${pxToRem(props.$initialWidth === 'wide' ? SIDEBAR_MAX_WIDTH : SIDEBAR_MIN_WIDTH)};`}
`;
export const FloatingSidebarContainer = styled.aside `
  ${floatingSidebarWidth};

  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100dvw;
  overflow: hidden;
  background-color: ${theme.semantic.surface.raised};
  border-left: solid ${pxToRem(1)} ${theme.semantic.border.default};
  box-shadow: ${theme.dropShadow[300]};
  transition:
    transform 0.2s ease-in-out,
    visibility 0.2s ease-in-out;
  transform: translateX(${(props) => (props.$open ? '0' : '100%')});
  visibility: ${(props) => (props.$open ? 'visible' : 'hidden')};

  ${breakpoints.desktop} {
    top: ${theme.spacing.sm};
    right: ${theme.spacing.sm};
    bottom: ${theme.spacing.sm};
    width: var(${FLOATING_SIDEBAR_CSS_VARIABLE_WIDTH});
    max-width: calc(100% - ${theme.spacing.xl});
    border: solid ${pxToRem(1)} ${theme.semantic.border.default};
    border-radius: ${theme.borderRadius.md};
    transform: translateX(${(props) => (props.$open ? '0' : '110%')});
  }
`;
export const FloatingSidebarHeader = styled.header `
  ${barStyles};
  padding: ${theme.spacing.lg} ${theme.spacing.lg} ${theme.spacing.lg} ${theme.spacing.xl};
  gap: ${theme.spacing.md};
  justify-content: space-between;
`;
export const FloatingSidebarBody = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;
export const FloatingSidebarFooter = styled.footer `
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  border-top: solid ${pxToRem(1)} ${theme.semantic.border.default};
  justify-content: flex-end;
`;
export const FloatingSidebarDraggableHover = styled(SidebarDraggableHover) `
  left: 0;
  margin-left: 0;
`;
